const TYPE = '[APP]'

export default {
    TRANSLATE: `${TYPE} TRANSLATE`,
}